export default "__VITE_ASSET__d211598b__"